export interface InsidePage {
  src: string
  alt: string
}

/** The five real interior pages of the product — do not replace with mockups. */
export const insidePages: InsidePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/osTEyrH2Nsp771YHKURJLK/Captura_de_pantalla_2026-10-21_a_la(s)_5.16.18_p._m..png',
    alt: 'Interior page: Intramuscular Injection Sites — Anatomical Landmarks & Risk Structures',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/vgU8mRk5vBN3YDFYCaVeF5/Captura_de_pantalla_2026-10-21_a_la(s)_5.31.21_p._m..png',
    alt: 'Interior page: Subcutaneous Injection — Tissue Assessment & Administration Safety',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/uWhTyLB6FNiJNxaT1dztNR/Captura_de_pantalla_2026-10-21_a_la(s)_5.31.35_p._m..png',
    alt: 'Interior page: Aseptic Preparation — Contamination Prevention & Occupational Safety',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/64KAoAq77jYMJyiiPrQkAJ/Captura_de_pantalla_2026-10-21_a_la(s)_5.31.54_p._m..png',
    alt: 'Interior page: Infusion Delivery Systems — Operational Differences & Clinical Limitations',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gkugrnQU4QyWeahHhuK2Fg/Captura_de_pantalla_2026-10-21_a_la(s)_5.15.36_p._m..png',
    alt: 'Interior page: Advanced Parenteral Administration — Route Selection & Clinical Considerations',
  },
]
